import * as angular from "angular"; 

import { directivesModule } from "../directivesModule";


		//This directive is used to display an image over the screen to indicate the app is loading. 
		//In order for this to work the top element in the app needs to be something like 
		//<!-- Overlay to show when the data is loading.  -->
		//<div bv-overlay="">
		//    <br /><img src="../Content/spinner.gif" />&nbsp;&nbsp;Loading
		//</div>


class OverlayController implements angular.IController {

	private overlayContainer: any; 

	constructor(private $scope:angular.IScope, private $window: angular.IWindowService) {
		//This uses angular events/signals to show and hide the overlay.  This means this directive does not
		//need to be called directly.  It can be called indirectly. 
		$scope.$on('showOverlay', () => {
			this.showOverlay();
		});

		$scope.$on('hideOverlay', () => {
			this.hideOverlay();
		});
	}

	public $onInit() { };


	public SetContainer(newContainer: any) {
		this.overlayContainer = newContainer;
	}

	public showOverlay() {
		var w = 0;
		var h = 0;
		if (!this.$window.innerWidth) {
			if (!(document.documentElement.clientWidth == 0)) {
				w = document.documentElement.clientWidth;
				h = document.documentElement.clientHeight;
			}
			else {
				w = document.body.clientWidth;
				h = document.body.clientHeight;
			}
		}
		else {
			w = this.$window.innerWidth;
			h = this.$window.innerHeight;
		}
		var content = document.getElementById('overlay-content');
		var contentWidth = parseInt(this.getComputedStyle(content, 'width').replace('px', ''));
		var contentHeight = parseInt(this.getComputedStyle(content, 'height').replace('px', ''));

		content.style.top = h / 2 - contentHeight / 2 + 'px';
		content.style.left = w / 2 - contentWidth / 2 + 'px';

		this.overlayContainer.style.display = 'block';
	}

	public hideOverlay() {
		this.overlayContainer.style.display = 'none';
	}

	public getComputedStyle(element, style) {
		var func = null;
		if (document.defaultView && document.defaultView.getComputedStyle) {
			func = document.defaultView.getComputedStyle;
		} else if (typeof ((<any>document.body).currentStyle) !== "undefined") {
			func = (element, anything) => {
				return element["currentStyle"];
			};
		}

		return func(element, null)[style];
	};

}

class OverlayDirective implements angular.IDirective {

	public restrict: string = 'EA';
	public transclude: boolean = true; 
	public controller: string = "OverlayController";
	public template: string = `<div id="overlay-container" class="overlayContainer"> 
			<div id="overlay-background" class="overlayBackground"></div>
			<div id="overlay-content" class="overlayContent" data-ng-transclude>
			</div></div>`;

	public link(scope: angular.IScope, element: JQuery, attrs: angular.IAttributes, controller: OverlayController) {
		controller.SetContainer(element[0].firstChild); //Get to template
	}
}

directivesModule.controller('OverlayController', ['$scope','$window',($scope,$window) =>new OverlayController($scope,$window)])
directivesModule.directive('bvOverlay', [() => new OverlayDirective()]);


// WEBPACK FOOTER //
// ./Common/Notifications/Overlay.ts